/* GENERATED FILE */
import  { useContext  } from "solid-js";
import { IconContext } from "../lib";

const renderPathFor = (weight: string, color: string) => {
  switch (weight) {
    case "bold":
      return (
        <>
          <rect x="101.13" y="35.13" width="53.74" height="53.74" transform="translate(-6.35 108.67) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="24"/><rect x="101.13" y="167.13" width="53.74" height="53.74" transform="translate(-99.69 147.33) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="24"/><rect x="35.13" y="101.13" width="53.74" height="53.74" transform="translate(-72.35 81.33) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="24"/><rect x="167.13" y="101.13" width="53.74" height="53.74" transform="translate(-33.69 174.67) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="24"/>
        </>
      )
    case "duotone":
      return (
        <>
          <rect x="99.72" y="35.72" width="56.57" height="56.57" transform="translate(-7.76 109.25) rotate(-45)" opacity="0.2"/><rect x="99.72" y="163.72" width="56.57" height="56.57" transform="translate(-98.27 146.75) rotate(-45)" opacity="0.2"/><rect x="163.72" y="99.72" width="56.57" height="56.57" transform="translate(-34.27 173.25) rotate(-45)" opacity="0.2"/><rect x="35.72" y="99.72" width="56.57" height="56.57" transform="translate(-71.76 82.75) rotate(-45)" opacity="0.2"/><rect x="99.72" y="35.72" width="56.57" height="56.57" transform="translate(-7.76 109.25) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><rect x="99.72" y="163.72" width="56.57" height="56.57" transform="translate(-98.27 146.75) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><rect x="163.72" y="99.72" width="56.57" height="56.57" transform="translate(-34.27 173.25) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><rect x="35.72" y="99.72" width="56.57" height="56.57" transform="translate(-71.76 82.75) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/>
        </>
      )
    case "fill":
      return (
        <>
          <path d="M82.34,69.66a8,8,0,0,1,0-11.32l40-40a8,8,0,0,1,11.32,0l40,40a8,8,0,0,1,0,11.32l-40,40a8,8,0,0,1-11.32,0Zm51.32,76.68a8,8,0,0,0-11.32,0l-40,40a8,8,0,0,0,0,11.32l40,40a8,8,0,0,0,11.32,0l40-40a8,8,0,0,0,0-11.32Zm104-24-40-40a8,8,0,0,0-11.32,0l-40,40a8,8,0,0,0,0,11.32l40,40a8,8,0,0,0,11.32,0l40-40A8,8,0,0,0,237.66,122.34Zm-128,0-40-40a8,8,0,0,0-11.32,0l-40,40a8,8,0,0,0,0,11.32l40,40a8,8,0,0,0,11.32,0l40-40A8,8,0,0,0,109.66,122.34Z"/>
        </>
      )
    case "light":
      return (
        <>
          <rect x="99.72" y="35.72" width="56.57" height="56.57" transform="translate(-7.76 109.25) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="12"/><rect x="99.72" y="163.72" width="56.57" height="56.57" transform="translate(-98.27 146.75) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="12"/><rect x="163.72" y="99.72" width="56.57" height="56.57" transform="translate(-34.27 173.25) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="12"/><rect x="35.72" y="99.72" width="56.57" height="56.57" transform="translate(-71.76 82.75) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="12"/>
        </>
      )
    case "thin":
      return (
        <>
          <rect x="99.72" y="35.72" width="56.57" height="56.57" transform="translate(-7.76 109.25) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="8"/><rect x="99.72" y="163.72" width="56.57" height="56.57" transform="translate(-98.27 146.75) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="8"/><rect x="163.72" y="99.72" width="56.57" height="56.57" transform="translate(-34.27 173.25) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="8"/><rect x="35.72" y="99.72" width="56.57" height="56.57" transform="translate(-71.76 82.75) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="8"/>
        </>
      )
    case "regular":
      return (
        <>
          <rect x="99.72" y="35.72" width="56.57" height="56.57" transform="translate(-7.76 109.25) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><rect x="99.72" y="163.72" width="56.57" height="56.57" transform="translate(-98.27 146.75) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><rect x="163.72" y="99.72" width="56.57" height="56.57" transform="translate(-34.27 173.25) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><rect x="35.72" y="99.72" width="56.57" height="56.57" transform="translate(-71.76 82.75) rotate(-45)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/>
        </>
      )
    default:
      console.error(
        'Unsupported icon weight. Choose from "thin", "light", "regular", "bold", "fill", or "duotone".'
      );
      return null;
  }
};

const DiamondsFour = (props: any, ref: any)  => {
  const { color, size, weight, mirrored, children, ...restProps } = props;
  const {
    color: contextColor,
    size: contextSize,
    weight: contextWeight,
    mirrored: contextMirrored,
    ...restContext
  } = useContext(IconContext);

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? contextSize}
      height={size ?? contextSize}
      fill={color ?? contextColor}
      viewBox="0 0 256 256"
      transform={mirrored || contextMirrored ? "scale(-1, 1)" : undefined}
      {...restContext}
      {...restProps}
    >
      {children}
      <rect width="256" height="256" fill="none"/>
      {renderPathFor(weight ?? contextWeight, color ?? contextColor)}
    </svg>
  );
};


export default DiamondsFour;
